import authApi from 'api/AuthApi';
import otpApi from 'api/OtpApi';
import accessTokenStorage from 'shared/lib/lib/accessTokenStorage';
import { createAction } from 'shared/lib/lib/callAPI';
import * as types from './types';

export function getAuthUser() {
  return createAction({
    type: types.GET_CURRENT_USER,
    callAPI: () => authApi.getAuthUser(),
    shouldCallAPI: (state) => !state.currentUser.data,
  });
}

const unwrapApiAction = (action) => {
  if (action && action.error) {
    throw action.error;
  }
  return action && action.response;
};

export function getPseudonymization() {
  return createAction({
    type: types.GET_PSEUDONYMIZATION,
    callAPI: () => authApi.getPseudonymization(),
  });
}

export function startPseudonymization() {
  return (dispatch) => dispatch(createAction({
    type: types.START_PSEUDONYMIZATION,
    callAPI: () => authApi.startPseudonymization(),
  })).then(unwrapApiAction);
}

export function cancelPseudonymization() {
  return (dispatch) => dispatch(createAction({
    type: types.CANCEL_PSEUDONYMIZATION,
    callAPI: () => authApi.cancelPseudonymization().then((response) => (
      dispatch(getAuthUser()).then(() => response)
    )),
  })).then(unwrapApiAction);
}

export function login(email, password) {
  return (dispatch) => authApi.login(email, password).then((data) => {
    accessTokenStorage.set(data.key);
    return dispatch(getAuthUser());
  });
}

// Login-Award-Redesign (Etappe E): E-Mail-Code-Login. confirm liefert denselben
// { key } wie der Passwort-Login -> identischer Token-Flow (Token setzen +
// currentUser laden), sodass isAuthenticated genauso greift und der Redirect
// im Login-Screen ueber denselben Weg laeuft.
export function loginWithEmailCode(email, code) {
  return (dispatch) => otpApi.confirm(email, code).then((data) => {
    accessTokenStorage.set(data.key);
    return dispatch(getAuthUser());
  });
}

export function logout() {
  return (dispatch) => authApi.logout().then(() => {
    accessTokenStorage.remove();
    dispatch({ type: types.LOGOUT });
  });
}
